import React from 'react';
import useSortableTable from './useSortableTable';
import './SortableTable.css';
import { calculateMarketValue, formatCurrency, formatDecimalPlaces, getRowKey} from './helpers';

function StockTable({ stocks, onDelete, onEdit, onUpdate, editQuantity, setEditQuantity, editingPosition }) {
  const columns = ['position', 'quantity', 'price', 'DFVScore', 'PriceTarget', 'PE', 'FPE', 'RSI', 'AnalystConsensus'];
  const { sortedData, requestSort, getSortClass } = useSortableTable(stocks, columns);

  return (
    <div>
      <h2>Stocks</h2>
      <div className="table-responsive-wrapper">
	<table>
        <thead>
          <tr>
            <th>Ticker</th>
            <th>Quantity</th>
            <th>Price</th>
            <th onClick={() => requestSort('marketValue')} className={getSortClass('marketValue')}>Market Value</th>
	    <th onClick={() => requestSort('DFVScore')} className={getSortClass('DFVScore')}>DFVScore</th>
            <th>PriceTarget</th>
	    <th onClick={() => requestSort('priceTargetDiff')} className={getSortClass('priceTargetDiff')}>PriceTargetDiff</th>
            <th>PE</th>
            <th>FPE</th>
            <th onClick={() => requestSort('RSI')} className={getSortClass('RSI')}>RSI</th>
            <th>AnalystConsensus</th>
	    <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map((item, index) => (
            <tr key={index}>
              <td>{item.position}</td>
              <td>{item.quantity}</td>
              <td>{formatCurrency(item.details?.Price) || '-'}</td>
	      <td>{formatCurrency(calculateMarketValue(item.quantity, item.details?.Price))}</td>
              <td>{formatDecimalPlaces(item.details?.DFVScore,2)}</td>
              <td>{item.details?.PriceTarget || '-'}</td>
              <td>{item.details?.PriceTargetDiff || '-'}</td>
              <td>{item.details?.PE || '-'}</td>
              <td>{item.details?.FPE || '-'}</td>
              <td>{item.details?.RSI || '-'}</td>
              <td>{item.details?.AnalystConsensus || '-'}</td>
	      <td>
                <button onClick={() => onDelete(item)}>Delete</button>
                {editingPosition === getRowKey(item) ? (
                  <div>
                    <input
                      type="number"
                      value={editQuantity}
                      onChange={(e) => setEditQuantity(e.target.value)}
                    />
                    <button onClick={() => onUpdate(item)}>Save</button>
                    <button onClick={() => onEdit(null)}>Cancel</button>
                  </div>
                ) : (
                  <button onClick={() => {onEdit(getRowKey(item));setEditQuantity(item.quantity);}}>Edit</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
}

export default StockTable;
